<template>
  <v-app>
    <v-app-bar
      v-if="topmenu"
      class="body-2"
      height="56"
      center
      fixed
      app
    />
    <v-content>
      <slot></slot>
    </v-content>

  </v-app>
</template>

<script>
/* ============
 * Minimal Layout
 * ============
 *
 * Used for the register and login pages.
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */
import { mapGetters } from 'vuex';
import TopMenuDisactivator from '@/mixins/TopMenuDisactivator';

export default {
  /**
   * The name of the layout.
   */
  name: 'MinimalLayout',
  mixins: [TopMenuDisactivator],
  computed: {
    ...mapGetters('project', ['projectLogo']),
  },
};
</script>
<style scoped>
.v-app-bar {
  color: var(--header-color, #616161) !important;
  caret-color: var(--header-color, #616161) !important;
  background-color: var(--header-background-color, #fafafa) !important;
  border-color: var(--header-background-color, #fafafa) !important;
}

.v-toolbar a, .v-toolbar a:hover {
  text-decoration: none;
  color: initial;
}

.logo {
  max-height: 100%;
  max-width: 100%;
}
</style>
